export const Hr = ({ sx }) => <hr style={sx} />;
